import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api from "@/lib/api";
import { Loader2, Save, ArrowLeftRight } from "lucide-react";

export default function FxRateCard({ defaultFxRate, onSaved }) {
  const [rate, setRate] = useState(defaultFxRate ?? 83.0);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const val = Number(rate);
    if (!(val > 0)) { toast.error("Enter a valid positive USD/INR rate"); return; }
    setSaving(true);
    try {
      await api.put("/collections/fx-rate", { usd_inr: val });
      toast.success("FX rate updated");
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card>
      <CardContent className="p-5 space-y-3" data-testid="fx-rate-card">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div>
            <h2 className="text-base font-bold text-slate-900 flex items-center gap-2">
              <ArrowLeftRight className="w-4 h-4 text-[#0066CC]" /> Default FX Rate — USD → INR
            </h2>
            <p className="text-xs text-slate-500">
              Used to pre-fill new USD receipts. The actual rate is <strong>snapshotted per receipt</strong> at creation time
              and never changes retroactively.
            </p>
          </div>
        </div>
        <div className="flex items-end gap-3 max-w-md">
          <div className="flex-1">
            <Label className="text-xs">1 USD = ? INR</Label>
            <Input
              type="number" step="0.01" min={0}
              value={rate}
              onChange={(e) => setRate(e.target.value)}
              className="h-10"
              data-testid="fx-rate-input"
            />
          </div>
          <Button onClick={save} disabled={saving} className="bg-[#0066CC] hover:bg-[#0052A3] h-10" data-testid="save-fx-rate-btn">
            {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
            Save Rate
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
